import type { ColDef } from 'ag-grid-community'
import type { Match } from '../../../../../api/useSupplierReconciliation/types/match'
import { getBasicColumns } from './columns/basicColumns'
import { getDateColumns } from './columns/dateColumns'
import { getFinancialColumns } from './columns/financialColumns'
import { getMetadataColumns } from './columns/metadataColumns'
import { getActionColumns } from './columns/actionColumns'

interface ServerParams {
  params?: any[]
}

export interface ColumnDefOptions {
  serverParams?: ServerParams
  getTimezoneForMatch?: (terminals?: string[]) => string | undefined
}

export function getMatchColumnDefs(options: ColumnDefOptions = {}): ColDef<Match>[] {
  const { serverParams, getTimezoneForMatch } = options

  return [
    ...getBasicColumns(serverParams),
    ...getDateColumns({ getTimezoneForMatch }),
    ...getFinancialColumns(),
    ...getMetadataColumns(serverParams),
    ...getActionColumns(),
  ]
}

// Re-export renderers for direct use if needed
export { StatusCellRenderer } from './renderers/StatusCellRenderer'
export { WarningsCellRenderer } from './renderers/WarningsCellRenderer'
export { BolNumbersCellRenderer } from './renderers/BolNumbersCellRenderer'
export { InvoiceNumbersCellRenderer } from './renderers/InvoiceNumbersCellRenderer'
export { OrderNumbersCellRenderer } from './renderers/OrderNumbersCellRenderer'
export { PoNumbersCellRenderer } from './renderers/PoNumbersCellRenderer'

// Re-export utilities
export { addCommasToNumber } from './utils/formatters'
// Currency formatters are now in shared/formatters.ts
export { formatCurrency, currencyFormatter } from '@/components/SupplierReconciliation/shared/formatters'
